export default __webpack_public_path__ + "static/media/loginImg.979fdf85.jpg";